module.exports = __webpack_public_path__ + "static/img/four.f152f2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/four.png
// module id = bIXf
// module chunks = 1